import { render, staticRenderFns } from "./customer-picker.vue?vue&type=template&id=8da3cc82&scoped=true"
import script from "./customer-picker.vue?vue&type=script&lang=js"
export * from "./customer-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da3cc82",
  null
  
)

export default component.exports